<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title61"></a>
<div class="p-c-br"><span><em class="i">To D.H.G, J.L., and B.B.B.</em> <br/><em class="i">with thanks, appreciation, and love</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429969635_ded01.vue?17938943